<template>
    <!-- Odoo 348733: переключатель движка графа «Classic / Lens» — в островке нижнего правого угла графа (AttrGraph — командная панель графа,
         при скрытой панели — островок шестерёнки; линза — свой островок в том же углу). Виден только там, где линза рисует данные
         (graph/lens/lensSwitch.js: сетевой граф DataHub или движок, заданный записью; никогда на графе с полосами). Клик пишет viewParams
         графа без пометки записи изменённой и личный выбор (localStorage); запросов к бэку нет -->
    <!-- IE 2026 11 02 / ODOO-350449 (заказ Игоря: p189 єдиний вигляд полос перемикачів — заголовки, відступи, Alt-підказки пунктів): «Classic / Lens» — общим SegSwitch (role radiogroup, размер sm), подсказки пунктов — по Alt -->
    <SegSwitch v-if="st.available" class="graph-engine-toggle" role="radiogroup" size="sm" :aria-label="t('Graph engine')"
        :label-help="{ key: 'chart.graph.engine', state: () => st.engine }" :items="items" :model-value="st.lens ? 'lens' : 'sigma'" @pick="set" />
</template>

<script>
import { useMainStore } from '@/stores/mainStore'
import { graphEngine_state, graphEngine_set } from './lensSwitch'
import SegSwitch from '@/components/ui/SegSwitch.vue'   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p189 єдиний вигляд полос перемикачів — заголовки, відступи, Alt-підказки пунктів)

export default {
    name: 'GraphEngineToggle',
    components: { SegSwitch },   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p189 єдиний вигляд полос перемикачів — заголовки, відступи, Alt-підказки пунктів)
    props: {
        widget: { type: Object, default: null },   // WIDGET графа
        attr: { type: Object, default: null },     // attr графа (attr_type AttrGraph)
    },
    setup() {
        return { store: useMainStore() }
    },
    computed: {
        st() { return graphEngine_state(this.store, this.widget, this.attr) },
        items() {   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p189 єдиний вигляд полос перемикачів — заголовки, відступи, Alt-підказки пунктів)
            return [{ key: 'sigma', title: this.t('Classic', null, 'graph engine'), tip: this.t('Classic graph: layout and settings of the platform graph') },
                { key: 'lens', title: this.t('Lens', null, 'graph engine'), tip: this.t('Lens: overview of a large network — areas, rings, links, neighbourhood') }]
        },
    },
    methods: {
        set(engine) {
            if (engine === this.st.engine || !this.widget || !this.attr) return
            graphEngine_set(this.store, this.widget, this.attr, engine)
        },
    },
}
</script>

<style>
/* IE 2026 11 02 / ODOO-350449 (заказ Игоря: p189 єдиний вигляд полос перемикачів — заголовки, відступи, Alt-підказки пунктів): вид — общий SegSwitch; в островке графа — без внешних отступов, впритык к соседним кнопкам */
.graph-engine-toggle.seg-set { flex: none; margin: 0 4px 0 0; }
</style>
